import {
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Button,
} from '@chakra-ui/react';
import React, { useState } from 'react';

type AddCollateralDataQualityCheckModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirmAdd: (name: string) => Promise<void>;
  isAddLoading: boolean;
};
export const AddCollateralDataQualityCheckModal = ({
  isOpen,
  onClose,
  onConfirmAdd,
  isAddLoading,
}: AddCollateralDataQualityCheckModalProps) => {
  const [name, setName] = useState<string>('');

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add Collateral Data Quality Check</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text mb="16px" fontWeight={600}>
            Name:
          </Text>
          <Input
            value={name}
            onChange={(event) => setName(event.target.value)}
            placeholder="eg. Eligibility Does Not Change"
          />
        </ModalBody>

        <ModalFooter>
          <Button
            colorScheme="aurora"
            variant="outline"
            borderWidth="2px"
            mr="32px"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            colorScheme="aurora"
            color="white"
            onClick={() => onConfirmAdd(name)}
            isLoading={isAddLoading}
          >
            Add
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
